import type { ExtensionManifest } from './types';
import { EXTENSION_MANIFESTS } from '../../supabase/functions/_shared/extension-manifests';

// Every first-party extension, in launcher order. The data is shared with the
// edge functions; UI pieces live in ./registry.ts.
export const MANIFESTS = EXTENSION_MANIFESTS as ExtensionManifest[];

export function getManifest(extensionId: string): ExtensionManifest | undefined {
  return MANIFESTS.find((m) => m.id === extensionId);
}
